import firebase from "firebase/app";
import "firebase/auth";
import api from "src/api/index";


export default {
  state: {
    loggedInUser:
      localStorage.getItem("userInfo") != null
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
    loading: false,
    error: null
  },
  getters: {
    loggedInUser: state => state.loggedInUser,
    //loginUserInfo: state => state.loggedInUser != null ? state.loggedInUser.user : null,
    loading: state => state.loading,
    error: state => state.error
  },
  mutations: {
    setUser(state, data) {      
      state.loggedInUser = data;
      state.loading = false;
      state.error = null;
    },
    setLogout(state) {
      state.loggedInUser = null;
      state.loading = false;
      state.error = null;
      // this.$router.go("/");
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setError(state, data) {
      state.error = data;
      state.loggedInUser = null;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    }
  },
  actions: {
    login({ commit }, data) {      
      commit("clearError");
      commit("setLoading", true);      
      api.auth.login(data)
      .then(rsp => {                
        const newUser = { ...rsp.data };
        localStorage.setItem("userInfo", JSON.stringify(newUser));        
        commit("setUser", newUser);
      })
      .catch(function(rsp) {                
        console.log(rsp.response.data.message);
        localStorage.removeItem("userInfo");
        commit("setError", rsp.response.data.message);        
      });
    },

    async signUserUp({ commit }, data) {
      // commit("setLoading", true);
      // commit("clearError");
      // auth.signUp()
      // .then(rspData => {
        
      //   console.log(rspData);
      // })
      // .finally(() => {
      //   commit("setLoading", false);
      // })



      // firebase
      //   .auth()
      //   .createUserWithEmailAndPassword(data.email, data.password)
      //   .then(user => {
      //     commit("setLoading", false);

      //     const newUser = {
      //       uid: user.user.uid
      //     };
      //     console.log(newUser);
      //     localStorage.setItem("userInfo", JSON.stringify(newUser));
      //     commit("setUser", newUser);
      //   })
      //   .catch(error => {
      //     commit("setLoading", false);
      //     commit("setError", error);
      //     localStorage.removeItem("userInfo");
      //     console.log(error);
      //   });
    },
    signOut({ commit }) {
      api.auth.logout()
      .then(rsp => {                
        localStorage.removeItem("userInfo");
        commit("setLogout");        
      })
      .catch(function(rsp) {                
        
      });
    //   firebase
    //     .auth()
    //     .signOut()
    //     .then(
    //       () => {
    //         localStorage.removeItem("userInfo");
    //         commit("setLogout");
    //       },
    //       _error => {}
    //     );
    }
  }
};
